import React from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { useThemeMode } from '../../../../../_metronic/partials';
import { recordsKeeperColors } from '../../core/_constants';

const StackedBarChart: React.FC<any> = ({ recordCountData }: { recordCountData: any }) => {
  const { mode } = useThemeMode();
  let result: any = [];
  let departments, categories;

  if (recordCountData?.length > 0) {
    // Extract department names
    departments = recordCountData?.map((item: any) => item.department);

    // Define document categories (excluding "department" key)
    categories = Object.keys(recordCountData[0]).filter((key) => key !== 'department');

    // Transform data into required format
    result = categories?.map((category) => ({
      name: category.charAt(0).toUpperCase() + category.slice(1).toLowerCase(),
      data: recordCountData.map((item: any) => item[category]),
    }));
  }

  const options: ApexOptions = {
    series: result,
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'top',
            offsetX: -10,
            offsetY: 0,
            itemMargin: {
              horizontal: 5, // Add spacing between legend items
              vertical: 5,
            },
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 10,
      },
    },
    tooltip: {
      y: {
        formatter: (val) => (Number.isInteger(val) ? val.toString() : val.toFixed(1)),
      },
    },
    xaxis: {
      type: 'category',
      categories: departments || [], // Ensure categories are strings
      labels: {
        style: {
          colors: mode === 'dark' ? '#ffffff' : '#000000', // Change X-axis labels color based on theme
          fontSize: '12px',
        },
        rotate: -45, // Rotate labels to prevent overlap
        formatter: (value: string) => {
          // Truncate label if it exceeds 15 characters
          if (value.length > 15) {
            return `${value.substring(0, 15)}...`;
          }
          return value;
        },
      },
      tooltip: {
        enabled: false, // Enable tooltip for full labels
        formatter: (value: string) => value, // Show full value in tooltip
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: mode === 'dark' ? '#ffffff' : '#000000', // Change Y-axis labels color based on theme
          fontSize: '12px',
        },
      },
    },
    legend: {
      position: 'bottom',
      offsetY: 8,
      labels: {
        colors: mode === 'dark' ? '#ffffff' : '#000000',
      },
      markers: {
        width: 10, // Adjust marker size
        height: 10, // Keep height same as width
        radius: 50, // High value makes the markers fully round
      },
    },
    colors: recordsKeeperColors, // Custom colors for each series
    fill: {
      opacity: 1,
    },
    grid: {
      show: true,
      borderColor: mode === 'dark' ? '#565674' : '#DBDFE9',
      strokeDashArray: 0,
      position: 'back',
    },
  };

  return (
    <div id="chart">
      <Chart options={options} series={options.series} type="bar" height={327} />
    </div>
  );
};

export default StackedBarChart;
